import config from "@/config"
import http from "@/utils/request"

export default {
  user: {
    set: {
      url: `${config.API_URL}/user`,
      name: "编辑一个顾客组账号",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user.item', auth: true, ...data });
      }
    },
    merge: {
      url: `${config.API_URL}/user`,
      name: "编辑一个顾客组账号",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user.merge', auth: true, ...data });
      }
    },
    password: {
      url: `${config.API_URL}/user`,
      name: "编辑顾客组账号密码",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user.password', auth: true, ...data });
      }
    },
    item: {
      url: `${config.API_URL}/user`,
      name: "获取一个顾客组账号详情",
      get: async function () {
        return await http.post(this.url, { method: 'get.user.item', auth: true, });
      }
    },
    list: {
      url: `${config.API_URL}/user`,
      name: "获取一个顾客组账号详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user.list', auth: true, ...data });
      }
    },
    findpwd: {
      url: `${config.API_URL}/login`,
      name: "忘记密码",
      post: async function (data) {
        return await http.post(this.url, { method: 'find.user.password', auth: false, ...data });
      }
    },
    sendcode: {
      url: `${config.API_URL}/login`,
      name: "获取短信验证码",
      post: async function (data) {
        return await http.post(this.url, { method: 'send.message.code', auth: false, ...data });
      }
    },
    mobilelogin: {
      url: `${config.API_URL}/login`,
      name: "用户登录",
      post: async function (data) {
        return await http.post(this.url, { method: 'user.mobile.login', auth: false, ...data });
      }
    },
    wxlogin: {
      url: `${config.API_URL}/login`,
      name: "用户登录",
      post: async function (data) {
        return await http.post(this.url, { method: 'user.wx.login', auth: false, ...data });
      }
    },
    wxbindmobile: {
      url: `${config.API_URL}/login`,
      name: "绑定微信号",
      post: async function (data) {
        return await http.post(this.url, { method: 'user.wx.mobile.bind', auth: true, ...data });
      }
    },
    openid: {
      url: `${config.API_URL}/login`,
      name: "用户登录",
      post: async function (data) {
        return await http.post(this.url, { method: 'get.wechat.qrcode', auth: false, ...data });
      }
    },
    getcode: {
      url: `${config.API_URL}/login`,
      name: "PC获取code后登录",
      post: async function (data) {
        return await http.post(this.url, { method: 'get.user.info.pc', auth: false, ...data });
      }
    },
    register: {
      url: `${config.API_URL}/login`,
      name: "用户注册",
      post: async function (data) {
        return await http.post(this.url, { method: 'register.user.item', auth: false, ...data });
      }
    },
    logout: {
      url: `${config.API_URL}/login`,
      name: "退出登录",
      post: async function () {
        return await http.post(this.url, { method: 'set.user.loginout', auth: true, });
      }
    }
  },
  user_money: {
    info: {
      url: `${config.API_URL}/user_money`,
      name: "获取指定账号资金信息",
      get: async function (client_id) {
        return await http.post(this.url, { method: 'get.user.money.info', client_id });
      }
    },
    loglist: {
      url: `${config.API_URL}/user_money`,
      name: "获取指定账号资金明细",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user.money.log.list', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/user_money`,
      name: "财务对账号进行资金调整",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user.money.item', ...data });
      }
    },
  },
  level: {
    add: {
      url: `${config.API_URL}/user_level`,
      name: "新增一个账号等级",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.user.level.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/user_level`,
      name: "编辑一个账号等级",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user.level.item', ...data });
      }
    },
    sort: {
      url: `${config.API_URL}/user_level`,
      name: "批量编辑账号等级排序",
      post: async function (user_level_id, sort) {
        return await http.post(this.url, { method: 'set.user.level.sort', user_level_id, sort });
      }
    },
    delete: {
      url: `${config.API_URL}/user_level`,
      name: "批量删除账号等级",
      post: async function (user_level_id) {
        return await http.post(this.url, { method: 'del.user.level.list', user_level_id });
      }
    },
    item: {
      url: `${config.API_URL}/user_level`,
      name: "获取一个账号等级详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user.level.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/user_level`,
      name: "获取账号等级列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user.level.list', ...data });
      }
    }
  },
  message: {
    list: {
      url: `${config.API_URL}/user_message`,
      name: "获取账号等级列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user_message.list', ...data });
      }
    },
    delete: {
      url: `${config.API_URL}/user_level`,
      name: "批量删除账号等级",
      post: async function (user_level_id) {
        return await http.post(this.url, { method: 'del.user.level.list', user_level_id });
      }
    },
    real: {
      url: `${config.API_URL}/user_message`,
      name: "获取一个账号等级详情",
      post: async function (data) {
        return await http.post(this.url, { auth: true, method: 'set.user_message.real', ...data });
      }
    },
    unread: {
      url: `${config.API_URL}/user_message`,
      name: "获取账号等级列表",
      get: async function (data) {
        return await http.post(this.url, {
          auth: true, method: 'get.user_message.unread', ...data
        });
      }
    }
  },
  browse_log: {
    add: {
      url: `${config.API_URL}/user_browse_log`,
      name: "新增一个用户浏览记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'add.user_browse_log.item', ...data });
      }
    },
    set: {
      url: `${config.API_URL}/user_browse_log`,
      name: "编辑一个用户浏览记录",
      post: async function (data) {
        return await http.post(this.url, { method: 'set.user_browse_log.item', ...data });
      }
    },
    delete: {
      url: `${config.API_URL}/user_browse_log`,
      name: "批量删除用户浏览记录",
      post: async function (user_browse_log_id) {
        return await http.post(this.url, { method: 'del.user_browse_log.list', user_browse_log_id });
      }
    },
    item: {
      url: `${config.API_URL}/user_browse_log`,
      name: "获取一个用户浏览记录详情",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user_browse_log.item', ...data });
      }
    },
    list: {
      url: `${config.API_URL}/user_browse_log`,
      name: "获取用户浏览记录列表",
      get: async function (data) {
        return await http.post(this.url, { method: 'get.user_browse_log.list', ...data });
      }
    }
  }

}
